module.exports = __webpack_public_path__ + "img/ico-refresh.0a1d80c6.svg";